import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function json_parse(a) {
  if (a == 'undefined') return '';
  return JSON.parse(a);
}

export const store = new Vuex.Store({
  state: {
    // form: null,
    survey: json_parse(localStorage.getItem('survey' || null)),
    startData: {
      name: localStorage.getItem('email') || '',
      email: localStorage.getItem('name') || '',
      respondent_function: localStorage.getItem('respondent_function') || ''
    },
    surveySettings: json_parse(localStorage.getItem('surveySettings'|| null)),
    info: {
      form_id: localStorage.getItem('form_id') || '',
      formName: localStorage.getItem('formName') || '',
      description: localStorage.getItem('description') || '',
      project: json_parse(localStorage.getItem('project')) || '',
      crow: false,
      contactperson: 'Paul Kegel',
      fillable_once: localStorage.getItem('fillable_once') || '',
      fillable_multiple_respondents: localStorage.getItem('fillable_multiple_respondents') || '',
      after_send_message: localStorage.getItem('after_send_message') || '',
      before_start_message: localStorage.getItem('before_start_message') || '',
      expire_message: localStorage.getItem('expire_message') || '',
      email_enabled: json_parse(localStorage.getItem('email_enabled' || '')),
      name_enabled: json_parse(localStorage.getItem('name_enabled' || '')),
      respondent_function_enabled: json_parse(localStorage.getItem('respondent_function_enabled' || '')),
      email_required: json_parse(localStorage.getItem('email_required' || '')),
      name_required: json_parse(localStorage.getItem('name_required' || '')),
      respondent_function_required: json_parse(localStorage.getItem('respondent_function_required' || '')),
      startdate: localStorage.getItem('startdate') || '',
      expirationdate: localStorage.getItem('expirationdate') || ''
    },
    token: localStorage.getItem('token') || '',
    crowMeta: json_parse(localStorage.getItem('crowMeta' || '')),
    status: localStorage.getItem('status') || 'no-survey',
    activities: json_parse(localStorage.getItem('activities' || '')),
    style: {
      primary: localStorage.getItem('primary_style') || '',
      secondary: localStorage.getItem('secondary_style') || '',
      fontColor: localStorage.getItem('font_style') || '',
      startButtonText: localStorage.getItem('startButtonText') || '',
      introText: localStorage.getItem('introText') || '',
      logo: localStorage.getItem('logo') || require('../../static/img/pd_logo_light.png')
    },
    active_activity: localStorage.getItem('active') || null,
    activeQuestion: localStorage.getItem('activeQuestion') || null,
    completedActivities: [],
    form_length: localStorage.getItem('formLength') || null,
    sendIsActive: false,
    surveyActive: null,
    surveySubmited: null,
    uploadedFiles: [],
    surveyType: 'single-page-survey', // survey or single-page-survey
    validate: json_parse(localStorage.getItem('validate' || false)),
    uploads: []
  },
  mutations: {
    clearUploads (state) {
      state.uploads = []
    },
    setSurvey (state, val) {
      state.survey = val
      localStorage.setItem('survey', JSON.stringify(val))
    },
    setSurveySettings (state, val) {
      state.surveySettings = val
      state.surveySettings.userEmail = '';
      localStorage.setItem('surveySettings', JSON.stringify(val))
    },
    setToken (state, val) {
      localStorage.clear()
      localStorage.setItem('token', val)
      state.token = val
      state.uplaods = []
    },
    setProject (state, val) {
      state.info.project = val.name
      localStorage.setItem('project', JSON.stringify(val.name))
    },
    setActivities (state, val) {
      state.activities = val
      localStorage.setItem('activities', JSON.stringify(val))
    },
    setInfo (state, val) {
      let form = val
      state.info.form_id = form._id
      state.info.formName = form.name
      state.info.description = form.description
      state.info.fillable_once = form.survey_settings.fillable_once
      state.info.fillable_multiple_respondents = form.survey_settings.fillable_multiple_respondents
      state.info.after_send_message = form.survey_settings.after_send_message
      state.info.before_start_message = form.survey_settings.before_start_message
      state.info.expire_message = form.survey_settings.expire_message
      state.info.email_enabled = form.survey_settings.enabled_email
      state.info.name_enabled = form.survey_settings.enabled_name
      state.info.respondent_function_enabled = form.survey_settings.enabled_function
      state.info.email_required = form.crow ? true : form.survey_settings.required_email
      state.info.name_required = form.survey_settings.required_name
      state.info.respondent_function_required = form.survey_settings.required_function
      if (form.survey_info) state.info.project = form.survey_info.project_name
      state.info.startdate = form.startdate
      state.info.expirationdate = form.expirationdate
      state.info.crow = form.crow
      state.crowMeta = form.crowMeta
      localStorage.setItem('form_id', form._id)
      localStorage.setItem('formName', form.name)
      localStorage.setItem('description', form.description)
      localStorage.setItem('fillable_once', form.survey_settings.fillable_once)
      localStorage.setItem('fillable_multiple_respondents', form.survey_settings.fillable_multiple_respondents)
      localStorage.setItem('after_send_message', form.survey_settings.after_send_message)
      localStorage.setItem('before_start_message', form.survey_settings.before_start_message)
      localStorage.setItem('expire_message', form.survey_settings.expire_message)
      localStorage.setItem('email_required', JSON.stringify(form.survey_settings.required_email))
      localStorage.setItem('name_required', JSON.stringify(form.survey_settings.required_name))
      localStorage.setItem('respondent_function_required', JSON.stringify(form.survey_settings.required_function))
      localStorage.setItem('email_enabled', JSON.stringify(form.survey_settings.enabled_email))
      localStorage.setItem('name_enabled', JSON.stringify(form.survey_settings.enabled_name))
      localStorage.setItem('respondent_function_enabled', JSON.stringify(form.survey_settings.enabled_function))
      if (form.survey_info) localStorage.setItem('projectName', form.survey_info.project_name)
      localStorage.setItem('startdate', form.startdate)
      localStorage.setItem('expirationdate', form.expirationdate)
      // localStorage.setItem('crow', JSON.stringify(form.crow))
      localStorage.setItem('crowMeta', JSON.stringify(form.crowMeta))
    },
    setStatus (state, val) {
      state.status = val
      localStorage.setItem('status', val)
    },
    setActiveActivity (state, val) {
      state.active_activity = val
      localStorage.setItem('active', val)
    },
    setActiveQuestion (state, val) {
      state.activeQuestion = val
      localStorage.setItem('activeQuestion', val)
    },
    addCompletedActivities (state, val) {
      // Add an activity to array: completedActivities
    },
    updateActivity (state, activities) {

      if (!activities) activities = [];
      // validate answers
      activities.forEach((activity) => {
        if (activity.filteredQuestions) {
          activity.filteredQuestions.forEach((question) => {
            if (question.type !== 1 && question.required === '1') {
              question.valid = false

              if (question.answer) {
                let valid = true
                if (question.answer instanceof Array) {
                  valid = question.answer.length > 0
                } else if (question.answer instanceof Number) {
                  valid = true
                } else {
                  if (question.answer) valid = true
                }
                question.valid = valid
              }
            }
          })
        }
      })
      localStorage.setItem('activities', JSON.stringify(state.activities))
    },
    SetSendIsActive (state, val) {
      state.sendIsActive = val
    },
    setStyle (state, val) {
      state.style.primary = val.primary_color
      localStorage.setItem('primary_style', val.primary_color)
      state.style.secondary = val.secondary_color
      localStorage.setItem('secondary_style', val.secondary_color)
      state.style.fontColor = val.font_color
      localStorage.setItem('font_style', val.font_color)
      state.style.logo = val.logo
      localStorage.setItem('logo', val.logo)
      state.style.introText = val.customIntroText
      localStorage.setItem('introText', val.customIntroText)
      state.style.startButtonText = val.customStartButtonText
      localStorage.setItem('startButtonText', val.customStartButtonText)
    },
    setUploadedFiles (state, data) {
      state.uploadedFiles.splice(0, 0, {id: data.id.$oid, file: data.file})
    },
    setSurveyActive (state, val) {
      localStorage.setItem('surveyActive', val)
      state.surveyActive = val
    },
    setSurveySubmited (state, val) {
      localStorage.setItem('surveySubmited', val)
      state.surveySubmited = val
    },
    setStartData (state, val) {
      state.startData = val
      localStorage.setItem('startData', JSON.stringify(val));
    },
    setSurveyType (state, val) {
      state.surveyType = val
    },
    setValidate (state, val) {
      state.validate = val
      localStorage.setItem('validate', JSON.stringify(val))
    },
    setUploads (state, val) {
      state.uploads = val
      // console.log('FROM STORE:')
      // console.log(state.uploads)
    },
    setFormlength (state, val) {
      state.form_length = val
      localStorage.setItem('formLength', val)
    }
  },
  getters: {
    getToken: state => state.token,
    getActivities: state => state.activities,
    getProject: state => state.info.project,
    clientStyle: state => state.style,
    getInfo: state => state.info,
    getCrowMeta: state => state.crowMeta,
    getCrow: state => state.info.crow,
    getStatus: state => state.status,
    getActiveActivity: state => state.active_activity,
    getActiveQuestion: state => state.activeQuestion,
    getFormLength: state => state.form_length,
    getCompletedActivities: state => state.completedActivities,
    GetSendIsActive: state => state.sendIsActive,
    getSurvey: state => state.survey,
    getSurveySettings: state => state.surveySettings,
    getUploadedFiles: (state) => (fid) => {
      return state.uploadedFiles.filter(file => file.id === fid)
    },
    getStartData: state => state.startData,
    getSurveyType: state => state.surveyType,
    getValidate: state => state.validate,
    getUploads: state => state.uploads
  },
  actions: {
    uploadFiles ({ commit, state }) {

    }
  }
})

// example form with all question types: https://metrictool.mijnemviprestatiemeting.nl/survey/get/4248613746643476746e49554449467568494261306143797a566c5438633547735877496758584a4a2f6d35706765366467437566503239732f7a6d742f79643032384e5a4234613163334d6f3444506f6e4248635a374730424f2b39654f79482f4e34566c34443250387473477354672b7546734a4e505578306e5969344e495a2b2b

// example json form: https://metrictool.mijnemviprestatiemeting.nl/survey/get/78366d6a65572b5334774a4f566a30546d454b79316456786e43576976544d514744573877663167455875674f716c5230332b33676d566f3373734a6b71726a546d686e447341354254336c56466258512f34585164573058364168634648765061526378757254362b5a6332356b6157654132456a5173437452436c3978732f577534

// heijmansStyle: {
//     primary: '#222a51',
//     secondary: '#1470e2',
//     fontColor: '#00294c',
//     logo: require('../assets/pd_logo_light.png')
// },
//
// heijmansStyle: {
//     primary: '#feb900',
//     secondary: '#003766',
//     fontColor: '#1470e2',
//     logo: require('../assets/heijmans-logo.png')
// },
// struktonStyle: {
//     primary: '#e63126',
//     secondary: '#3f2682',
//     fontColor: '#3f2682',
//     logo: require('../assets/strukton-logo.png')
// },
// dusseldorpStyle: {
//     primary: '#f6b407',
//     secondary: '#222221',
//     fontColor: '#222221',
//     logo: require('../assets/dusseldorp-logo.png')
// },
// vialisStyle: {
//     primary: '#002f6d',
//     secondary: '#36aa1b',
//     fontColor: '#36aa1b',
//     logo: require('../assets/vialis-logo.jpg')
// },
// krinkelsStyle: {
//     primary: '#9ecc41',
//     secondary: '#222221',
//     fontColor: '#222221',
//     logo: require('../assets/krinkels-logo.png')
// }



// WEBPACK FOOTER //
// ./src/store/store.js